import React from 'react';
import { Box, Flex, Icon, Text } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import QFIcon from '@/components/QFIcon';
import { getMilitaryTime } from '@/lib/date';
import Flight from '@/propTypes/Flight';

const FlightDetail = ({ flight }) => {
  const { arrival, departure, destination, duration, flightNumber, origin } =
    flight;

  const { hour, minute } = getMilitaryTime(duration);

  return (
    <>
      <Flex alignItems="center" mb="4">
        <QFIcon inline />
        <Text pl="2" fontWeight="bold">
          {`${flightNumber}  ${origin.name} to ${destination.name}`}
        </Text>
      </Flex>
      <Flex alignItems="center">
        <Icon name="circleBorder" color="greys.alto" size="16px" />
        <Text pl="2" fontSize="sm">
          <b>{`${departure.time} `}</b>
          {`${origin.name} (${origin.code})`}
        </Text>
      </Flex>
      <Box
        ml="7px"
        pl="4"
        borderLeft="2px dashed"
        borderColor="greys.alto"
        height="44px"
      >
        <Text color="greys.steel" fontSize="sm" lineHeight="44px">
          {`Duration ${hour}h ${minute}m`}
        </Text>
      </Box>
      <Flex alignItems="center">
        <Icon name="circleBorder" color="greys.alto" size="16px" />
        <Text pl="2" fontSize="sm">
          <b>{`${arrival.time} `}</b>
          {`${destination.name} (${destination.code})`}
        </Text>
      </Flex>
    </>
  );
};

FlightDetail.propTypes = {
  flight: PropTypes.shape(Flight).isRequired,
};

export default FlightDetail;
